import React from 'react';
import ReactDOM from 'react-dom';
import Reflux from 'reflux';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { Col, Input, Overlay, Popover, Row } from 'bootstrap';
import classnames from 'classnames';
import Tag from 'shared/components/tag/tag';
import { List, OrderedMap } from 'immutable';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import ModalStore from 'shared/flux/stores/ModalStore';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import ModalActions from 'shared/flux/actions/ModalActions';
import RouteActions from 'shared/flux/actions/RouteActions';
import CreateLabelModal from 'main/components/show/cuesheet.globalElement/createLabelModal';

const defaultPopoverId = 'filterTagMenu';

export default React.createClass({
  mixins: [
    PureRenderMixin,
    Reflux.connect(PopoverStore, 'popoverVisibility'),
    Reflux.connect(ModalStore, 'modalVisibility'),
  ],

  displayName: 'FilterTagMenu',

  propTypes: {
    popoverId: React.PropTypes.string,
    popoverTitle: React.PropTypes.string,
    popoverClasses: React.PropTypes.string,
    wrapperClasses: React.PropTypes.string,
    onChange: React.PropTypes.func,
    onCreate: React.PropTypes.func,
    placement: React.PropTypes.string,
    tags: React.PropTypes.object,
    activeTagIds: React.PropTypes.array,
    displayNode: React.PropTypes.string,
    displayClear: React.PropTypes.bool,
    disableCreateEdit: React.PropTypes.bool,
    disableSearch: React.PropTypes.bool,
    disableSelection: React.PropTypes.bool,
    disableSorting: React.PropTypes.bool,
    clearText: React.PropTypes.string,
    isFilter: React.PropTypes.bool,
    teamId: React.PropTypes.string,
    eventId: React.PropTypes.string,
  },

  getDefaultProps() {
    return {
      placement: 'bottom',
      popoverId: defaultPopoverId,
      popoverTitle: 'All Tags',
      clearText: 'Clear all',
      activeTagIds: List(),
      tags: OrderedMap(),
    };
  },

  getInitialState() {
    return {
      searchTerm: '',
      searchedTagMatches: null,
      searchFocusState: false,
    };
  },

  render() {
    const {
      popoverId,
      tags,
      displayNode,
      // activeTagId,
      wrapperClasses,
      teamId,
      eventId,
    } = this.props;

    const { popoverVisibility, searchTerm } = this.state;

    if (!tags) return null;

    return (
      <span
        className={wrapperClasses}
        onClick={() => this._togglePopoverVisibility()}
      >
        {this._isModalVisible() ? (
          <CreateLabelModal
            modalId={popoverId}
            defaultText={searchTerm}
            teamId={teamId}
            eventId={eventId}
            onCreateCompleted={this._handleTagCreation}
          />
        ) : null}
        <span ref="target">{displayNode}</span>
        <Overlay
          rootClose
          show={popoverVisibility.get(popoverId)}
          onHide={this._handleHidePopover}
          placement={this.props.placement}
          container={document.body}
          target={() => ReactDOM.findDOMNode(this.refs.target)}
        >
          {this._getPopoverNode()}
        </Overlay>
      </span>
    );
  },

  _isModalVisible() {
    const { popoverId } = this.props;
    return this.state.modalVisibility.get(popoverId) ? true : false;
  },

  _handleHidePopover() {
    const { popoverId } = this.props;

    this._clearSearchTerm();
    PopoverActions.hide(popoverId);
  },

  _togglePopoverVisibility() {
    const { popoverId } = this.props;
    const { popoverVisibility } = this.state;

    if (popoverVisibility.get(popoverId)) return PopoverActions.hide(popoverId);
    PopoverActions.show(popoverId);
  },

  _getPopoverNode() {
    const {
      displayClear,
      disableSearch,
      clearText,
      popoverTitle,
      popoverClasses,
    } = this.props;
    const { searchTerm, searchFocusState } = this.state;

    return (
      <Popover className={classnames('ge-popover', popoverClasses)}>
        <Row>
          <Col lg={14} md={14} sm={14}>
            <label className="ge-popover-title">{popoverTitle}</label>
          </Col>
          {displayClear ? (
            <Col lg={10} md={10} sm={10}>
              <div
                onClick={() => this._clearAllSelectedTags()}
                className="ge-popover-header-btn"
              >
                {clearText}
              </div>
            </Col>
          ) : null}
        </Row>
        <Row>
          <Col lg={24} md={24} sm={24}>
            {disableSearch ? null : (
              <div className="search-container-header-input">
                <span
                  className={classnames('search-wrapper', {
                    'has-focus': searchFocusState,
                  })}
                >
                  <Input
                    type="text"
                    autoFocus
                    placeholder="Search for tag"
                    className={classnames('search-input', {
                      'has-value': searchTerm.length > 0,
                    })}
                    value={searchTerm}
                    addonBefore={<span>{this._getSearchPreControl()}</span>}
                    onChange={(e) => this._handleSearchChange(e.target.value)}
                    onFocus={() => this._toggleSearchInputFocus()}
                    onBlur={() => this._toggleSearchInputFocus()}
                  />
                </span>
              </div>
            )}
          </Col>
        </Row>
        <Row className="ge-popover-list-wrapper">
          <Col lg={24} md={24} sm={24}>
            {this._getTagNodes()}
          </Col>
        </Row>
      </Popover>
    );
  },

  _clearAllSelectedTags() {
    let { onChange } = this.props;
    onChange(List());
  },

  _getTagItems() {
    const { tags, disableSorting } = this.props;
    const { searchTerm } = this.state;

    const sortedTags = disableSorting
      ? tags
      : tags.sort((a, b) => {
          if (a.get('text') < b.get('text')) return -1;
          if (a.get('text') > b.get('text')) return 1;
          return 0;
        });

    if (!searchTerm) return sortedTags;

    const searchRegex = new RegExp(searchTerm, 'ig');

    // let tagMatches = sortedTags.filter((tag, tagId) => {
    return sortedTags.filter((tag) => {
      return tag.get('text').match(searchRegex);
    });
  },

  _getTagNodes() {
    const { popoverId, teamId, disableCreateEdit } = this.props;
    const { searchTerm } = this.state;

    const tagItems = this._getTagItems();

    if (tagItems.size < 1 && searchTerm && !disableCreateEdit) {
      return (
        <div className="ge-popover-action-wrapper">
          <Row className={classnames('ge-popover-action-item-create')}>
            <div
              onClick={() => {
                ModalActions.show(popoverId);
                this._togglePopoverVisibility();
              }}
            >
              <Icon name="tag" /> Create new tag "{searchTerm}"
            </div>
          </Row>
          <Row className={classnames('ge-popover-action-item-edit')}>
            <div
              onClick={() => RouteActions.goToTeamDash({ teamId, tabId: 6 })}
            >
              <Icon name="edit" /> Edit tags
            </div>
          </Row>
        </div>
      );
    }

    return tagItems.map((tag) => {
      const { activeTagIds, disableSelection } = this.props;
      const isSelected = activeTagIds.indexOf(tag.get('_id')) !== -1;

      return (
        <Row
          key={tag.get('_id')}
          className={classnames('ge-popover-list-elements-item', {
            selected: isSelected,
          })}
        >
          {disableSelection ? null : (
            <div className="ge-popover-list-tag-select">
              {this._getMultiSelectionIconNode(tag, isSelected)}
            </div>
          )}
          <div
            className="ge-popover-list-tag"
            onClick={() => this._handleTagSelection(tag.get('_id'))}
          >
            <Tag
              color={tag.get('color')}
              text={tag.get('text')}
              key={tag.get('_id')}
            />
          </div>
        </Row>
      );
    });
  },

  _getMultiSelectionIconNode(tag, isSelected) {
    return (
      <input
        type="checkbox"
        value={tag.get('_id')}
        checked={isSelected}
        onChange={() => this._handleTagSelection(tag.get('_id'))}
      />
    );
  },

  _handleTagCreation(tag) {
    let { onChange, activeTagIds, popoverId } = this.props;

    activeTagIds = activeTagIds.push(tag._id);

    onChange(activeTagIds);

    ModalActions.hide(popoverId);
  },

  _handleTagSelection(tagId) {
    let { onChange, activeTagIds, disableSelection } = this.props;

    if (disableSelection) return;

    const tagIndex = activeTagIds.indexOf(tagId);

    if (tagIndex !== -1) {
      activeTagIds = activeTagIds.delete(tagIndex);
    } else {
      activeTagIds = activeTagIds.push(tagId);
    }

    onChange(activeTagIds);
  },

  _toggleSearchInputFocus() {
    const { searchFocusState } = this.state;
    this.setState({ searchFocusState: !searchFocusState });
  },

  _getSearchPreControl() {
    const { searchTerm } = this.state;
    const hasValue = searchTerm.length < 1 ? false : true;

    const searchNode = (
      <span className="search-prefix-wrapper">
        <Icon name="search" />
      </span>
    );

    const removeNode = (
      <span
        onClick={() => this._clearSearchTerm()}
        className="search-prefix-wrapper remove"
      >
        <Icon name="times" />
      </span>
    );

    return hasValue ? removeNode : searchNode;
  },

  _clearSearchTerm() {
    this.setState({ searchTerm: '' });
  },

  _handleSearchChange(searchTerm) {
    return this.setState({ searchTerm });
  },
});
